module.exports = __webpack_public_path__ + "static/media/personsIcon.0ef35ce8.png";